export const enum DarkModeEvents {
  DarkModeToggle = 'Dark mode toggle',
}
